export default __webpack_public_path__ + "static/media/Ground_AO.6895f393.png";